import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgIndicatorMarkdown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 25 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M21.073 5.727v11.75m-3.346-1.959 3.137 2.755L24 15.518m-10.454 2.755V5.727h-.966l-4.825 11.65H6.79L1.965 5.726H1v12.546"
	})
});
export default SvgKgIndicatorMarkdown;
